// @flow

import PrimaryButton from "@cabonline/shared/components/buttons/PrimaryButton"
import { Icon } from "antd"
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  width: calc(100% - 20px);
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.25);
  position: absolute;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  bottom: 10px;
  min-height: 97px;
`

const HeaderRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 5px;
`

const OptionsText = styled.div`
  font-size: 16px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  align-self: flex-start;
  width: 90%;
`

type Props = {
  cancelButtonText: string,
  headingText: string,
  onCancelButtonClick: Function,
  disableCancelButton: boolean
}

const SummaryOptionsModal = (props: Props, ref: any) => {
  const [isVisible, setIsVisible] = useState(false)

  const showModal = () => {
    setIsVisible(true)
  }

  const hideModal = () => {
    setIsVisible(false)
  }

  useImperativeHandle(ref, () => {
    return {
      showModal: showModal
    }
  })

  const node: { current: null | HTMLDivElement } = useRef(null)
  const stateRef = useRef(isVisible)

  const escapeListener = useCallback((e: KeyboardEvent) => {
    if (e.key === "Escape") {
      setIsVisible(false)
    }
  }, [])

  useEffect(() => {
    stateRef.current = isVisible
  }, [isVisible])

  useEffect(() => {
    const clickListener = (e: MouseEvent) => {
      const el: EventTarget | null = e.target
      const domNode = node.current
      if (
        stateRef.current &&
        domNode &&
        el &&
        el instanceof Node &&
        !domNode.contains(el)
      ) {
        setIsVisible(false)
      }
    }

    // Attach the listeners on component mount.
    document.addEventListener("click", clickListener)
    document.addEventListener("keyup", escapeListener)
    // Detach the listeners on component unmount.
    return () => {
      document.removeEventListener("click", clickListener)
      document.removeEventListener("keyup", escapeListener)
    }
  }, [])

  const onCancelOrderClicked = () => {
    props.onCancelButtonClick()
    hideModal()
  }

  return (
    <div ref={node}>
      <Wrapper style={{ display: isVisible ? "block" : "none" }}>
        <HeaderRow>
          <OptionsText>{props.headingText}</OptionsText>
          <Icon
            type="close"
            onClick={hideModal}
            style={{ cursor: "pointer" }}
          />
        </HeaderRow>
        <PrimaryButton
          htmlType="submit"
          style={{
            backgroundColor: "#c20000",
            color: "white",
            width: "100%",
            maxWidth: "none"
          }}
          disabled={props.disableCancelButton}
          onClick={onCancelOrderClicked}
        >
          {props.cancelButtonText}
        </PrimaryButton>
      </Wrapper>
    </div>
  )
}

export default (forwardRef<Props, any>(
  SummaryOptionsModal
): React$AbstractComponent<Props, any>)
